import React from 'react'
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Main from '../components/Main';



const Home = () => {
        return (
                <div>
                        <Header />
                        <Navigation />
                        <Main />
                        <Footer />
                </div>
        )
}


export default Home;
